import React, { useState, useEffect } from 'react'
import "./About1.css"

import useLocalStorage from 'use-local-storage';
// import AOS from 'aos';
// import Popup from '../popup/Popup';
import { MdOutlineFileDownload } from "react-icons/md";
import Swal from 'sweetalert2';
import Footer1 from '../footer/Footer1';
import BackToTop from "../BackToTop"
import Marque from '../Marque';

import UchennaImage from "../../assets/uakubueAvater.png"
import Socials from '../socials/Socials';
import Navbar from '../navbar/Navbar';



const About1 = () => {

    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        setTimeout(() => {

            setIsLoading(false);
        },1000);        
    },[])

    const [theme, ] = useLocalStorage('theme' ? 'dark': 'light')

    //  const themeSwitch = () => {
    //     const newTheme = theme === 'light' ? 'dark' : 'light';
    //      setTheme(newTheme)
    //  }
  
//   useEffect(() => {
//     AOS.init();
//   },[])

    const popUp = () => {
        Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Resume downloaded Successfully',
            showConfirmButton: false,
            timer: 2000
        })
    }

    const coverLetterPopUp = () => {
        Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Cover Letter downloaded Successfully',
            showConfirmButton: false,
            timer: 2000
        })
    }




  return (
    <div>
        {
            isLoading ? (<div class="load" data-theme={theme}><hr/><hr/><hr/><hr/></div>) : (
                <>
                    <Navbar />  
                    <div id='about' className='about_section pb-12  px-7'>
                        <div className="hero__info_div ">
                            <h1 className="text-[var(--text-secondary)] font-techFont">
                                All about <span>Uchenna...</span>
                                <strong>the Engineer</strong>
                            </h1>
                            
                        </div>
                
                        <div  className='about_content_section mx-auto grid md:grid-cols-1 items-center md:justify-between'>
                            <div className='about_img_section'>
                                <div className='about_img_div'>
                                    <img className='about__img' src={UchennaImage} alt="Uchenna's img" />
                                </div>
                            </div>

                            <div className='about_info_section'>
                                <div className="about_socials">
                                    <Socials />
                                </div>
                                <p className='font-cormorant'> 
                                    A goal-oriented Front-End Developer with over 3 years experience specialising in creating 
                                    mobile-responsive designs. Often make use of vanilla CSS as a foundation and occasionally enhance it with CSS 
                                    libraries such as Tailwind CSS, Bootstrap, Sass, and MaterialUI. Additionally, Also have a knack for translating 
                                    client requirements into scale-able patterns using React components, 
                                    resulting in well-structured and functional applications. 
                                    <br /> <br />
                                    Very passionate about crafting applications that offer a seamless user experience on mobile 
                                    devices. <br />
                                    The journey as a Front-End Developer is marked by a distinct set of skills and expertise that contribute to success in various roles. This includes meticulous execution, attention to detail, and a proactive approach to problem-solving. Front-end developers often thrive in fast-paced environments and demonstrate a proven ability to manage multiple priorities simultaneously. The capacity to prioritise tasks and consistently meet deadlines is integral in supporting teams and ensuring smooth organisational operations. Additionally, exceptional support can be provided to senior executives and teams by leveraging communication tools for seamless collaboration and efficient information flow.
                                    Furthermore, being a collaborative team player and continually seeking opportunities for organisational improvement and growth are key attributes in this field.
                                    <br /> <br />
                                    With strong oral and written communication skills, as well as attentive listening and a dedicated client-focused approach. Effectively handling customer complaints, providing timely solutions and alternatives to ensure swift resolution, are also important aspects of the role.
                                </p>
                                {/* <a href="UCHENNA AKUBUE RESUME.pdf" download className='flex items-center justify-center'>
                                    <button onClick={popUp} id='resume_btn' style={{alignItem:"center"}} className='text-white text-[25px] px-2 py-3 flex items-center  text-center  cursor-pointer font-techFont'>Download Resume
                                        <div className='download_icon'><MdOutlineFileDownload /></div>
                                    </button>
                                </a> */}

                                <div className='download_buttons_container' style={{display: 'flex', gap: '1em', flexWrap: 'wrap'}}>
                                    <a href="UCHENNA AKUBUE RESUME.pdf" download>
                                        <button onClick={popUp} className='resume__btn'><MdOutlineFileDownload /> Download Resume</button>
                                    </a>
                                    
                                    <a href="cover-letter.pdf" download>
                                        <button onClick={coverLetterPopUp} className='resume__btn'><MdOutlineFileDownload /> Download Cover Letter</button>
                                    </a>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <Marque />
                    <Footer1 />
                    <BackToTop />
                </>
            )
        }
    </div>
  )
}

export default About1